<style lang="scss" scoped>
.search {
    // padding: 15px 0;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    margin-bottom: 15px;
    border: 1px solid #eee;

    &-form-content {
        width: 70%;
        section {
            margin-bottom: 15px;
        }
    }
    &-button-content {
        padding-right: 15px;
    }
}
</style>
<style lang="scss">
.rules-container {
    .search {
        .search-form-content {
            .vview-formitem {
                margin-bottom: 5px;
            }
            .ivu-date-picker {
                width: 100%;
            }
        }
    }
    .rule-list {
        table {
            font-size: 12px;
        }
    }
}
</style>
<template>
    <div class="rules-container">
        <div class="search">
            <div class="search-form-content">
                <compFormEdit
                    class="search-form"
                    ref="searchForm"
                    :formdata="getBase"
                    v-model="formData.search"
                    :labelWidth="80"
                ></compFormEdit>
            </div>
            <div class="search-button-content">
                <Button type="primary" icon="ios-search" @click="search">{{$t('global.common.search',{defaultValue:'搜索'})}}</Button>
                <Button class="margin-left-15" type="default" icon="ios-refresh" @click="reset"
                    >{{$t('global.common.reset',{defaultValue:'重置'})}}</Button
                >
            </div>
        </div>
        <div class="rules-content">
            <!-- <compWrapper theme="error" title="高优先级仓库（需要优先发货的仓库）">
                <div class="title-button">
                    <Button type="primary">添加</Button>
                </div>
            </compWrapper> -->
            <compRulesList class="rule-list"
                v-for="item in indexShowList"
                :key="item.key"
                v-bind="item"
                :search="formData.search"
                :updateNow="updateNow"
            ></compRulesList>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import compRulesList from "./rulesList";
import mixin from './mixin'
export default {
    mixins: [mixin],
    components: {
        compRulesList,
    },
    data() {
        return {
            warehouseList: [],
            formData: {
                search: {}
            },
            loading: true,
            updateNow: 0,
        };
    },
    created() {
        // console.log(this.getNewWarehouseIdList)
        this.warehouseList = this.getNewWarehouseIdList
            .filter((item) => {
                // 过滤只展示服务仓和虚拟仓
                return (
                    item.attach.item.warehouseType === 1 ||
                    item.attach.item.warehouseType === 5
                );
            })
            .map((item) => {
                return item;
            });
    },
    computed: {
        ...mapGetters("diction", [
            "getNewProductList",
            "getNewAccountIdList",
            "getNewWarehouseIdList",
        ]),
        getBase() {
            let commonProps = {
                span: 8,
                required: false,
            };
            return [
                {
                    label: this.$t('erp.b2c.channel_account',{defaultValue:'渠道账号'}),
                    key: "channelId",
                    tag: "Select",
                    // class:"height30",
                    options: this.getNewAccountIdList,
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                    ...commonProps,
                },
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    key: "productId",
                    tag: "Select",
                    options: this.getNewProductList,
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                    ...commonProps,
                },
                {
                    label: this.$t('erp.b2c.search_outwarehouse',{defaultValue:'发货仓库'}),
                    key: "IN_warehouseId",
                    tag: "Select",
                    options: this.warehouseList,
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                    ...commonProps,
                },
                {
                    label: this.$t('global.common.status',{defaultValue:'状态'}),
                    key: "EQ_ruleStatus",
                    tag: "Select",
                    options: this.statusList,
                    ...commonProps,
                },
                {
                    label: this.$t('erp.distribution.issfp',{defaultValue:'是否SFP'}),
                    key: "EQ_sfpType",
                    tag: "Select",
                    options: this.sfpList,
                    ...commonProps,
                },
                {
                    label: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    key: "BT_updatedAt",
                    tag: "vDatepicker",
                    props: {
                        type: "daterange",
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    ...commonProps,
                },
            ];
        },
    },
    methods: {
        search () {
            this.updateNow ++;
        },
        reset () {
            this.formData.search = {}
            this.updateNow ++;
        },
    }
};
</script>